document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".bc").length) {
    function bc() {
      document.querySelectorAll(".bc").forEach(function (bcElement) {
        let heights = [];
        let padding = 0;

        if (bcElement.getAttribute("padding") !== null) {
          padding = parseInt(bcElement.getAttribute("padding"));
        }

        // Check if the parent has the class 'slider'
        const isSlider = bcElement.closest(".slider");
        let restoreVisibility = false;

        // Temporarily make all slide items visible if in a slider
        if (isSlider) {
          const allItems = bcElement.querySelectorAll(".swiper-slide, .carousel-item");
          allItems.forEach((item) => {
            if (
              item.style.display === "none" ||
              getComputedStyle(item).display === "none"
            ) {
              item.style.display = "block";
              restoreVisibility = true;
            }
            item.style.visibility = "hidden";
            item.style.position = "absolute";
          });
        }

        // Measure heights of all .b elements
        bcElement.querySelectorAll(".b").forEach(function (bElement) {
          const height = bElement.offsetHeight + padding;
          heights.push(height);
        });

        // Restore visibility if changed
        if (isSlider && restoreVisibility) {
          const allItems = bcElement.querySelectorAll(".swiper-slide, .carousel-item");
          allItems.forEach((item) => {
            item.style.visibility = "";
            item.style.position = "";
            item.style.display = "";
          });
        }

        const max = Math.max(...heights);

        // Apply the max height to all elements
        bcElement.querySelectorAll(".b").forEach(function (bElement) {
          bElement.style.height = max + "px";
          bElement.style.maxHeight = "unset";
        });
      });
    }

    setTimeout(bc, 50);

    window.addEventListener("resize", bc);
    bc();
  }
});
